import React, { createContext, useState, useEffect, useReducer } from "react";
import createInstance from "../api/axiosinstance";
import Toast from "../utils/toast";

const ACCESS_TOKEN_KEY = "accessToken";
const USER_NAME = "name";
const ADMIN_ID = "admin_id";
const ORGANIZATION_ID = "organization_id";

const LoginContext = createContext();

const loginReducer = (state, action) => {
  switch (action.type) {
    case "login":
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
        adminId: action.payload.adminId,
        organizationId: action.payload.organizationId,
        role: action.payload.role,
      };
    case "logout":
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        adminId: null,
        organizationId: null,
        role: null,
      };
    default:
      return state;
  }
};

const initialState = {
  isLoggedIn: false,
  user: null,
  adminId: null,
  organizationId: null,
  role: null,
};

const LoginProvider = ({ children }) => {
  const [loginStatus, setLoginStatus] = useState(null);
  const [state, dispatch] = useReducer(loginReducer, initialState);


  const dishaApi = createInstance("DISHA");

  const login = async (username, password) => {
    try {
      const response = await dishaApi.post(
        "/admin-user-Login",
        `username=${encodeURIComponent(username)}&password=${encodeURIComponent(
          password
        )}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      
      const data = response.data;
      console.log("logindata",data.role)
      console.log("loginname",data.name)
      setLoginStatus(data);
      
      // Store in localStorage for persistent auth
      localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token);
      localStorage.setItem(USER_NAME, data.name);
      localStorage.setItem(ADMIN_ID, data.admin_id || "");
      localStorage.setItem(ORGANIZATION_ID, data.organization_id || "");
      
      // Store role in sessionStorage for role-based authorization
      window.sessionStorage.setItem("role", data.role);
      window.sessionStorage.setItem("name", data.name);

      dispatch({
        type: "login",
        payload: {
          user: data.name,
          adminId: data.admin_id || null,
          organizationId: data.organization_id || null,
          role: data.role,
        },
      });
      
      return data;
    } catch (error) {
      console.error("Error logging in:", error);
      Toast.error(error.response?.data?.message || "Login failed. Please try again.");
      return null;
    }
  };

  // Organization user login (Interviewer & OrgAdmin)
  const orgUserLogin = async (username, password) => {
    try {
      const response = await dishaApi.post(
        "/org-user-Login",
        `username=${encodeURIComponent(username)}&password=${encodeURIComponent(
          password
        )}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      
      const data = response.data;
      setLoginStatus(data);
      console.log("logindata",data.role)
      console.log("loginname",data.name)
      
      // Store in localStorage for persistent auth
      localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token || "");
      localStorage.setItem(USER_NAME, data.name || "");
      localStorage.setItem(ORGANIZATION_ID, data.organization_id || "");
      
      // Store additional info in sessionStorage
      window.sessionStorage.setItem("role", data.role);
      window.sessionStorage.setItem("name", data.name);
      window.sessionStorage.setItem("organizationId", data.organization_id || "");
      window.sessionStorage.setItem("orgUserId", data.panelist_id || "");

      dispatch({
        type: "login",
        payload: {
          user: data.name,
          adminId: null,
          organizationId: data.organization_id || null,
          role: data.role,
        },
      });
      
      return data;
    } catch (error) {
      console.error("Error logging in:", error);
      Toast.error(error.response?.data?.message || "Login failed. Please try again.");
      return null;
    }
  };

  const logout = () => {
    try {
      setLoginStatus(null);
      
      // Clear localStorage items
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(USER_NAME);
      localStorage.removeItem(ADMIN_ID);
      localStorage.removeItem(ORGANIZATION_ID);
      
      // Clear sessionStorage items
      window.sessionStorage.removeItem("role");
      window.sessionStorage.removeItem("organizationId");
      window.sessionStorage.removeItem("orgUserId");

      dispatch({ type: "logout" });
    } catch (error) {
      console.error("Error in logout", error);
    }
  };

  // Check if user is authenticated on component mount
  useEffect(() => {
    const storedAccessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    // const storedUserName = localStorage.getItem(USER_NAME);
    const storedAdminId = localStorage.getItem(ADMIN_ID);
    const storedOrganizationId = localStorage.getItem(ORGANIZATION_ID);
    const storedRole = window.sessionStorage.getItem("role");
    const storedUserName = window.sessionStorage.getItem("name");

    if (storedAccessToken) {
      dispatch({
        type: "login",
        payload: {
          user: storedUserName,
          adminId: storedAdminId || null,
          organizationId: storedOrganizationId || null,
          role: storedRole,
        },
      });
    }
  }, []);

  return (
    <LoginContext.Provider value={{ 
      ...state, 
      login, 
      orgUserLogin, 
      logout,
      isAuthenticated: state.isLoggedIn
    }}>
      {children}
    </LoginContext.Provider>
  );
};

export { LoginContext, LoginProvider };